import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  carrousellContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#FFF',
    minHeight: 500,
    marginBottom: 60,
    marginTop: 110,
    paddingTop: 32,
    paddingLeft: 80,
    textAlign: 'justify',
    fontFamily: 'MonserratBold',
    [theme.breakpoints.down('md')]: {
      height: 400,
      paddingLeft: 4,
      width: '100%',
      paddingTop: 15,
      paddingRight: 10,
    },
    [theme.breakpoints.down('xs')]: {
      height: 400,
      paddingLeft: 4,
      width: '100%',
      paddingTop: 15,
      paddingRight: 10,
    },
  },
  carousel: {
    width: '100%',
    height: 380,
    [theme.breakpoints.down('md')]: {
      height: 320,
    },
    [theme.breakpoints.down('xs')]: {
      height: 280,
    },
  },
  slideContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    gap: '60px',
    padding: '20px 0',
    [theme.breakpoints.down('md')]: {
      gap: '40px',
    },
    [theme.breakpoints.down('xs')]: {
      gap: '20px',
      flexWrap: 'wrap',
    },
  },
  img: {
    width: 210,
    height: 210,
    objectFit: 'contain',
    [theme.breakpoints.down('md')]: {
      width: 180,
      height: 180,
    },
    [theme.breakpoints.down('xs')]: {
      width: 160,
      height: 160,
    },
  },
  title: {
    color: '#010C2B',
    // width: 700,
    fontSize: 30,
    fontWeight: 700,
    marginBottom: 12,
    textAlign: 'left',
    lineHeight: 1.43,
    letterSpacing:'0.01071em',
    [theme.breakpoints.down('md')]: {
      marginLeft: 15,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 22,
      marginBottom: 4,
      lineHeight: 1,
      marginLeft: 15,
    },
  },
  title2: {
    color: '#010C2B',
    textAlign: 'left',
    lineHeight: 1.43,
    letterSpacing:'0.01071em',
    // width: 700,
    fontSize: 30,
    fontWeight: 400,
    [theme.breakpoints.down('md')]: {
      marginLeft: 15,
    },
    [theme.breakpoints.down('xs')]: {
      // width: '100%',
      fontSize: 20,
      lineHeight: 0.7,
      paddingTop: 7,
      paddingBottom: 7,
      marginLeft: 15,
    },
  },
  navButton: {
    backgroundColor: 'rgba(1, 12, 43, 0.8)',
    borderRadius: '50%',
    color: 'white',
    margin: '0 10px',
  },
  indicatorContainer: {
    marginTop: '20px',
  },
  indicatorIconButton: {
    color: '#010C2B',
  },
  activeIndicatorIconButton: {
    color: '#4CAF50',
  },
}));

export default useStyles;
